jQuery(document).ready(function($) {
  // Für alle Card-Grids auf der Seite
  $('.component-card-grid').each(function() {
      var $gridContainer = $(this);
      var gridId = $gridContainer.attr('id') || 'grid-' + Math.random().toString(36).substr(2, 9);
      $gridContainer.attr('id', gridId);
      
      // NUR das .component-inner DIREKT unter .component-card-grid
      var $grid = $gridContainer.children('.component-inner');
      // Cards: alle direkten Kinder von .component-inner
      var $cards = $grid.children('.component-card');
      
      // Finde das zugehörige Filter-Element durch data-grid-id
      var $filter = $('.card-grid-filter[data-grid-id="' + gridId + '"]');

      // Nur initialisieren wenn ein Filter vorhanden ist
      if ($filter.length) {
          // Initialisiere Isotope
          var iso = $grid.isotope({
              itemSelector: '.component-card',
              layoutMode: 'fitRows',
              fitRows: {
                  gutter: 12 // Entspricht dem gap von .75rem
              },
              // Warte auf Bilder, bevor das Layout berechnet wird
              imagesLoaded: true,
              // Stagger-Effekt für bessere Performance
              stagger: 30,
              // Transition-Dauer
              transitionDuration: '0.4s'
          });

          $filter.on('click', 'button', function() {
              setCardsLoading($grid.find('.component-card'), true);
              var filterValue = $(this).attr('data-filter');
              if (filterValue === 'all' || filterValue === '*') {
                  iso.isotope({ filter: '*' });
              } else {
                  iso.isotope({ filter: '.' + filterValue });
              }
              $(this).addClass('is-active').siblings().removeClass('is-active');
          });

          // "Alle" Button standardmäßig als aktiv markieren
          $filter.find('button[data-filter="all"]').addClass('is-active');

          // Nach allen Bildern Layout berechnen
          setCardsLoading($grid.find('.component-card'), true);
          $grid.imagesLoaded(function() {
              iso.isotope('layout');
              // Warte, bis das Layout und die Höhenanpassung durch sind
              setTimeout(function() {
                  matchCardHeights();
                  setCardsLoading($grid.find('.component-card'), false);
              }, 400); // 400ms passend zur transitionDuration
          });

          // Bei Fenster-Resize Layout berechnen
          var resizeTimer;
          $(window).on('resize', function() {
              setCardsLoading($grid.find('.component-card'), true);
              clearTimeout(resizeTimer);
              resizeTimer = setTimeout(function() {
                  iso.isotope('layout');
                  matchCardHeights();
                  iso.isotope('layout');
                  setTimeout(function() {
                      setCardsLoading($grid.find('.component-card'), false);
                  }, 400); // 400ms passend zur transitionDuration
              }, 800);
          });

          // arrangeComplete-Handler für nachträgliche Aktionen
          $grid.on('arrangeComplete', function() {
              setTimeout(function() {
                  matchCardHeights();
                  setCardsLoading($grid.find('.component-card'), false);
              }, 400);
          });
      } else {
          // Wenn kein Filter vorhanden ist, nur die Bildhöhen anpassen
          $cards.find('img').each(function() {
              var $img = $(this);
              $img.on('load', function() {
                  var $card = $img.closest('.component-card');
                  var cardWidth = $card.width();
                  var imgHeight = (cardWidth * $img.data('aspect-ratio')) || $img.height();
                  $img.height(imgHeight);
              });
              if (this.complete) {
                  $(this).trigger('load');
              }
          });
      }
  });

  // --- HIER: matchCardHeights und Events ---
  function matchCardHeights(withLoading = true, focusCard = null) {
    if (focusCard) {
      // Nur die Zeile der übergebenen Card anpassen
      var $card = $(focusCard);
      var $row = $card.closest('.component-inner');
      var cardTop = $card.position().top;
      // Finde alle Cards in derselben Zeile
      var $rowCards = $row.find('.component-card:visible').filter(function() {
        return $(this).position().top === cardTop;
      });
      // Höhe zurücksetzen
      $rowCards.css('height', 'auto');
      // Maximale Höhe bestimmen
      var maxHeight = 0;
      $rowCards.each(function() {
        maxHeight = Math.max(maxHeight, $(this).outerHeight());
      });
      // Höhe setzen
      $rowCards.css('height', maxHeight + 'px');
      return;
    }
    // Standard: alle Zeilen im Grid anpassen
    $('.component-card-grid > .component-inner').each(function() {
      var $row = $(this);
      var rowTop = null;
      var cardsInRow = [];
      var maxHeight = 0;
      // Alle Cards auf auto-Höhe zurücksetzen
      $row.find('.component-card:visible').css('height', 'auto');
      // Cards durchgehen und pro Zeile die höchste Höhe bestimmen
      $row.find('.component-card:visible').each(function() {
        var $card = $(this);
        var cardTop = $card.position().top;
        if (rowTop === null) {
          rowTop = cardTop;
        }
        // Neue Zeile erkannt
        if (cardTop !== rowTop) {
          $(cardsInRow).css('height', maxHeight + 'px');
          cardsInRow = [];
          maxHeight = 0;
          rowTop = cardTop;
        }
        cardsInRow.push($card[0]);
        maxHeight = Math.max(maxHeight, $card.outerHeight());
      });
      // Letzte Zeile angleichen
      if (cardsInRow.length) {
        $(cardsInRow).css('height', maxHeight + 'px');
      }
    });
    // Overlay nur wenn gewünscht UND Grid hat Filter
    $('.component-card-grid').each(function() {
      var $grid = $(this);
      if ($grid.data('has-filters') === true || $grid.data('has-filters') === 'true') {
    if (withLoading) {
          $grid.find('.component-card').each(function() {
        setCardsLoading($(this), true);
      });
      setTimeout(function() {
            $grid.find('.component-card').each(function() {
          setCardsLoading($(this), false);
        });
      }, 400);
    }
      }
    });
  }

  // Beim Laden, nach Isotope-Layout und beim Resize ausführen
  $(window).on('load resize', matchCardHeights);

  function setCardsLoading($cards, loading = true) {
    if (loading) {
      $cards.addClass('is-loading');
    } else {
      $cards.removeClass('is-loading');
    }
  }
});